import { colors, radius } from "./tokens";

export default {
  palette: {
    primary: {
      light: colors.mist,
      main: colors.brand,
      dark: colors.brandDeep,
      contrastText: colors.white
    },
    secondary: {
      light: colors.mist,
      main: colors.ink,
      dark: colors.brandDeep,
      contrastText: colors.white
    },
    background: {
      default: colors.paper
    },
    text: {
      primary: colors.ink,
      secondary: colors.muted
    }
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: radius.pill
      },
      contained: {
        boxShadow: "0 8px 20px rgba(23,50,63,.15)"
      }
    },
    MuiCard: {
      root: {
        borderRadius: radius.medium
      }
    }
  }
};
